import { doc, updateDoc } from "firebase/firestore"
import { getToken, onMessage } from "firebase/messaging"
import { useEffect, useState } from "react"
import { auth, db } from "../firebase"

export function useSetNotifications(userId) {

    const [hasPermission, setHasPermission] = useState(false)

    useEffect(() => {

        if(!userId) {
            return () => null
        }
        
        async function getPermission() {
            
            try {
                
                var token = await getToken()
                const uid = auth?.currentUser?.uid

                await updateDoc(doc(db, "clients", uid), {
                    token
                })
                setHasPermission(true)

            } catch(err) { }

        }

        getPermission().catch(err => console.log(err))

    }, [userId])

    useEffect(() => {

        onMessage(notification => {
            alert(notification.notification.body)
        })

    }, [])

    return hasPermission

}